import {Schema, FieldSet, FieldComponent, Component, $} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'
import CheckboxWithOptions from '@/components/CheckboxWithOptions.vue'
import {PanelUserInfo} from '@/model/resource/PanelUserInfo'
export class InputPanelUserFlagsWithOptionsSchema extends Schema {
  readonly name = 'InputPanelUser'
  readonly fieldSet: FieldSet<PanelUser> = {
    integrationEnabled: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.panelUserFlags?.integrationEnabled,
        optionValue: schema.model.panelUserInfo?.tmsIntegration,
        optionType: 'text',
        optionLabel: $.t('schema.InputResponsavel.integracaoTMS'),
        inputClass: 'uppercase',
        class: 'col-span-2',
      },
      on: {
        updateOption: (val: string) => {
          if (schema.model.panelUserInfo == null) {
            schema.model.panelUserInfo = new PanelUserInfo()
          }
          schema.model.panelUserInfo.tmsIntegration = val
        },
      },
    }),
    hasControlTower: (schema): FieldComponent => ({
      is: CheckboxWithOptions,
      bind: {
        flagLabel: this.translateFrom(schema.fieldName),
        flagValue: schema.model.panelUserFlags?.hasControlTower,
        optionValue: schema.model.panelUserInfo?.towerControlManagerName,
        optionType: 'text',
        optionLabel: $.t(
          'schema.InputResponsavel.nomeResponsavelTorreDeControle'
        ),
        inputClass: 'uppercase',
        class: 'col-span-2',
      },
      on: {
        updateOption: (val: string | null) => {
          if (schema.model.panelUserInfo == null) {
            schema.model.panelUserInfo = new PanelUserInfo()
          }
          schema.model.panelUserInfo.towerControlManagerName = val
        },
      },
    }),
  }
}
